import comp from "./NodeTreeEditor";
export default comp;
